module.exports = __webpack_public_path__ + "static/media/MAYUR CV.15b63cfa.pdf";